import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const PlatformIntro = () => {
  const { currentTheme } = useTheme();
  
  return (
    <section className={`py-20 px-6 bg-gradient-to-br ${currentTheme.colors.primary} text-white`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Text content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-left"
          >
            <div className="mb-6 flex items-center">
              <img src="/images/logo.png" alt="Indie Music Creators Logo" className="h-20 w-20 md:h-24 md:w-24 object-contain" />
            </div>
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              Indie Music Creators
            </h2>
            <p className="text-2xl md:text-3xl mb-8 text-purple-200 font-semibold">
              A transformational music education movement
            </p>

            <div className="space-y-6 text-lg md:text-xl mb-12">
              <p className="leading-relaxed">
                Indie Music Creators is my flagship community where aspiring musicians learn to create, produce, and launch pro quality original music in a structured, supportive environment.
              </p>
              
              <div className="space-y-4 text-2xl font-bold">
                <p>This is not just a course.</p>
                <p className="text-purple-300">It’s a movement for those ready to become original indie artists.</p>
              </div>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => window.open('https://indiemusiccreators.com/', '_blank')}
              className="bg-white text-purple-900 hover:bg-purple-100 font-bold py-4 px-8 rounded-lg text-lg transition-all shadow-2xl"
            >
              👉 Explore the Community →
            </motion.button>
          </motion.div>

          {/* Right side - Profile image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex justify-center items-center"
          >
            <img 
              src="/images/Mere mehboob skin c.png" 
              alt="Mukesh Rathore" 
              className="w-full max-w-lg rounded-lg shadow-2xl object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PlatformIntro;